import type { MouseEvent } from 'react';
import { formatPriceOrDash, sumAvailablePrices } from '../../Utils/priceSimulationUtils';
import SpirisIcon from '../Fundamentals/Icon/SpirisIcon';
import PackageStructureGroupRow from './PackageStructureGroupRow';
import type { DisplayTier } from './PriceSimulation.types';

interface PackageStructureTierRowProps {
    tier: DisplayTier;
    isExpanded: boolean;
    onToggle: () => void;
}

const PackageStructureTierRow = ({ tier, isExpanded, onToggle }: PackageStructureTierRowProps) => {
    const handleSummaryClick = (event: MouseEvent) => {
        event.preventDefault();
        onToggle();
    };

    const totalPrice = sumAvailablePrices(tier.productGroups.flatMap((group) => group.products.map((product) => product.price)));

    return (
        <details className="collapse-list" open={isExpanded}>
            <summary className="collapse-list-header bg-secondary rounded-8 overflow-hidden" onClick={handleSummaryClick}>
                <div className="collapse-list-title py-12 px-16">
                    <SpirisIcon name="consolidated-accounts" className="mr-8" />
                    <span className="heading-md">{tier.name}</span>
                    <span className="d-flex align-items-center gap-12 ml-auto">
                        <span className="text-secondary font-weight-normal">{formatPriceOrDash(totalPrice)}</span>
                        <span className="caret"></span>
                    </span>
                </div>
            </summary>
            {isExpanded && (
                <div className="collapse-list-content d-flex flex-column gap-8 py-8 pl-32">
                    {[...tier.productGroups]
                        .sort((a, b) => b.productGroupType - a.productGroupType)
                        .map((group) => (
                            <PackageStructureGroupRow key={group.id} group={group} />
                        ))}
                </div>
            )}
        </details>
    );
};

export default PackageStructureTierRow;
